module.exports = __webpack_public_path__ + "img/pic.a69f5da6.svg";